import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import { Box, CircularProgress, Typography } from '@mui/material';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const performSignOut = async () => {
      try {
        await signOut();
        navigate('/login', { replace: true });
      } catch (error) {
        console.error('Error signing out:', error);
        navigate('/login', { replace: true });
      }
    };

    performSignOut();
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="h6">Signing you out...</Typography>
    </Box>
  );
};

export default Logout;